import classNames from 'classnames';
import { Icon, IconProps } from '@components/icon';
import './AvatarIcon.scss';

export type AvatarIconProps = Omit<IconProps, 'size'>;

export const AvatarIcon: React.FC<AvatarIconProps> = ({ className, name, ...rest }) => (
  <Icon className={classNames('vds-avatar-icon', className)} name={name} {...rest} />
);
